import React from "react";
import { playAffirm } from "../lib/sounds";

/** Big green "Start Smash" CTA. Used at the start of every smash flow. */
export const StartButton = ({ onClick, testId = "start-smash-btn", label = "Start Smash" }) => (
  <button
    data-testid={testId}
    onClick={() => { playAffirm(); onClick && onClick(); }}
    className="mt-10 w-full rounded-full py-5 font-bold text-lg tracking-[0.18em] uppercase text-[#0A090D] flex items-center justify-center gap-2 transition-all hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_30px_rgba(52,211,153,0.55)]"
    style={{
      background: "linear-gradient(135deg, #22C55E 0%, #34D399 50%, #4ADE80 100%)",
      border: "2px solid #86EFAC",
    }}
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 4l14 8-14 8V4z" fill="#0A090D" />
    </svg>
    {label}
  </button>
);
